import url from "/vercel/path0/src/pages/DonationsAndEarnings/images/donations-hero.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDonationsHero = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Layer 1",
	width: 829.13137,
	height: 587.67633,
	viewBox: "0 0 829.13137 587.67633",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polygon", {
			points: "85.757 572.858 99.518 572.857 106.065 519.775 85.754 519.776 85.757 572.858",
			fill: "#ffb6b6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.70638,743.3758l42.31934-.00159v-.5352a16.47278,16.47278,0,0,0-16.47186-16.47161h-.001l-7.73017-5.86451-14.42279,5.86541-3.6942.00012Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "107.98 508.635 118.814 517.121 156.702 479.371 140.712 466.846 107.98 508.635",
			fill: "#ffb6b6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M284.17936,675.79953l33.31553,26.096.33005-.42131a16.47278,16.47278,0,0,0-2.80933-23.12453l-.0008-.00063-2.46884-9.38365L297.575,664.68859l-2.90822-2.278Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M358.205,422.93653s18.2647,18.94117,10.147,62.91176l6.815,75.288,1.75885,3.4852a11.05057,11.05057,0,0,1-2.05152,12.7927l0,0-1.44882,4.49294-1.35294,8.79411-50.39706,75.76471-19.27941-20.29412,31.11765-71.02941L325.0579,556.8777l-19.61765-63.58823L291.91084,609.64241l2.70588,100.11765h-25.895L252.67554,598.14241,235.76378,441.20123l8.79678-18.2647Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239.9813,455.48237l-.18455-.25887c-9.85645-13.79924,4.96766-46.95846,7.20349-51.76534h0a12.068,12.068,0,0,1-8.26034-12.88863l.96382-8.193,1.00466-8.03624-7.19742-7.19743-.02023-.17949-4.142-36.24246-6.02235-24.07187a52.84836,52.84836,0,0,1,15.00007-51.21624l13.92059-2.21044,16.91786-16.30057h27.282l9.35438,8.93736c17.46254,3.06264,20.46254,2.06264,35.46254,20.06264l-6.81593,55.96246-1.70034,7.69872.00506,10.442,4.3228,4.80417a14.9496,14.9496,0,0,1,3.54622,12.93155l-.56848,2.84229h0c4.45834,1.91063,8.7126,35.86551,9.729,40.60831l1.51828,7.08466c1.29892,1.714,9.87263,13.146,9.87263,16.27119,0,.46921-.34634.92275-1.0896,1.4259-5.84288,3.95643-29.1375,32.0225-43.43072,26.303-15.22507-6.0876-75.74715,3.04481-76.35692,3.13784Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.3159,390.40721s7.006-39.59457-.05212-54.48539l-28,2,4.2612,56.48653,24.47719,62.71748a11.15409,11.15409,0,1,0,18.07814-6.46292Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#ffb6b6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.26378,314.92182l1.73291-18.87121a54.10668,54.10668,0,0,1,19.40277-36.75185l0,0a23.68674,23.68674,0,0,1,24.78746-3.27207h0a23.63086,23.63086,0,0,1,12.2047,29.86636c-6.47152,16.97245-4.13467,34.92127-16.75349,37.10949l1.37095,6.52243-12.40737,40.49039-35.338-4.09353Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M394.64075,371.64072s-20.50947-34.58577-35.571-41.27186L339.147,350.14467l40.06691,40.04408,59.45621,31.5844a11.15409,11.15409,0,1,0,9.49054-16.68887Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#ffb6b6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M324.148,332.70817l-10.99271-15.43651a54.1067,54.1067,0,0,1-9.25751-40.515l0,0a23.68675,23.68675,0,0,1,16.65778-18.6452h0a23.63089,23.63089,0,0,1,28.72919,14.68292c6.16209,17.08723,28.63861,45.17047,20.49917,55.05846l5.29279,4.05067,7.99879,22.78731L353.616,374.63235Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 95.53081,
			cy: 42.58672,
			r: 30.29866,
			fill: "#ffb6b6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M258.97664,220.10456c-.26447-.23195-.51409-.47962-.77257-.718-.00927.02445-.01069.04951-.02056.07389Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.79474,166.7531a17.18191,17.18191,0,0,0-6.06724-5.84973,25.38007,25.38007,0,0,0-5.30373-1.8792l-4.795-1.30828a38.01279,38.01279,0,0,0-7.54406-1.519,19.41849,19.41849,0,0,0-17.73713,9.62263c-1.44868,2.56955-2.61073,5.77154-5.40672,6.71164-2.2545.75806-4.71428-.31122-7.08371-.10378a8.52953,8.52953,0,0,0-6.47573,4.77,18.38025,18.38025,0,0,0-1.6989,8.14123,45.619,45.619,0,0,0,14.52158,34.048c.782-2.0613-.506-4.28678-1.52419-6.25861-1.03025-1.99521-1.66692-4.77683.05858-6.21382,1.92-1.599,4.99614-.04843,7.26683-1.09117a5.07328,5.07328,0,0,0,2.5361-4.0766c.21979-1.65672-.00968-3.34077.09431-5.00877a12.54224,12.54224,0,0,1,13.41165-11.73009c5.16845.36919,10.18434,3.90094,15.15812,2.448,2.33471-.682,4.326-2.41847,6.74066-2.71055,2.6742-.32351,5.18987,1.1857,7.46056,2.63484A26.59618,26.59618,0,0,0,305.79474,166.7531Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.83368,726.35315l-7.71-12.39-1.54,7.08008c-.27,1.24-.54,2.5-.79,3.75-2.19-1.87011-4.52-3.60009-6.79981-5.26q-10.5-7.62012-20.99023-15.26l2.18994,12.69995c1.3501,7.82007,2.76025,15.80005,6.1001,22.95.37011.81005.77,1.6101,1.20019,2.39013h32.54a10.48736,10.48736,0,0,0,.54-2.24011.77479.77479,0,0,0,.00976-.15C416.09394,735.07312,413.41376,730.50317,410.83368,726.35315Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M974.91649,712.97217l-13.98493-22.474-2.79345,12.8424c-.48978,2.24919-.97956,4.53469-1.433,6.802-3.97229-3.39217-8.19877-6.53014-12.334-9.541q-19.04573-13.822-38.07373-27.6798l3.97229,23.03617c2.44891,14.18465,5.00676,28.65936,11.06483,41.62841.67135,1.46935,1.39672,2.92054,2.177,4.33542h59.02367a19.0236,19.0236,0,0,0,.97957-4.06329,1.40483,1.40483,0,0,0,.01771-.27213C984.458,728.78914,979.59644,720.49981,974.91649,712.97217Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1013.375,743.53083l-826.75.30734a1.19069,1.19069,0,0,1,0-2.38137l826.75-.30734a1.19069,1.19069,0,0,1,0,2.38137Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#cacaca"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M444.83223,394.45926V681.48318A13.80575,13.80575,0,0,0,458.627,695.278h425.34a13.80568,13.80568,0,0,0,13.79481-13.79481V394.45926A13.81238,13.81238,0,0,0,883.967,380.6797H458.627A13.81244,13.81244,0,0,0,444.83223,394.45926Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454.8105,398.03051v279.912a7.38533,7.38533,0,0,0,7.37255,7.37255H880.42634a7.38528,7.38528,0,0,0,7.37256-7.37255v-279.912a7.38861,7.38861,0,0,0-7.37256-7.3879H462.18305A7.38866,7.38866,0,0,0,454.8105,398.03051Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M435.93667,737.4605a8.27165,8.27165,0,0,0,6.5087,3.114h455.4391a8.3806,8.3806,0,0,0,8.19191-10.0996l-7.06983-33.58132a8.39574,8.39574,0,0,0-5.21812-6.088,8.12058,8.12058,0,0,0-2.97378-.561H449.48711a8.11987,8.11987,0,0,0-2.97378.561,8.395,8.395,0,0,0-5.21812,6.088l-7.06983,33.58132A8.37419,8.37419,0,0,0,435.93667,737.4605Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 873.55259,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1575.69819 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 845.49795,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1519.58891 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 817.44331,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1463.47963 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 789.38867,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1407.37035 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 761.33403,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1351.26107 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 733.27939,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1295.15179 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 705.22475,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1239.04251 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 677.17011,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1182.93323 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 649.11547,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1126.82395 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 621.06083,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1070.71467 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 593.00619,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1014.60539 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 564.95155,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(958.49611 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 536.89691,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(902.38683 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 508.84227,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(846.27755 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 480.78763,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(790.16827 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 452.733,
			y: 696.29254,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(734.05899 1244.83964) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 873.8841,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1576.3612 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 845.82946,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1520.25192 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 817.77482,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1464.14264 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 789.72018,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1408.03336 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 761.66554,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1351.92408 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 733.6109,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1295.8148 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 705.55626,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1239.70552 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 677.50162,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1183.59624 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 649.44698,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1127.48696 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 621.39234,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1071.37768 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 593.3377,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1015.2684 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 565.28306,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(959.15912 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 537.22842,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(903.04984 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 509.17378,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(846.94056 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 481.11914,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(790.83128 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 453.0645,
			y: 710.31986,
			width: 14.02732,
			height: 8.41639,
			rx: .48819,
			transform: "translate(734.722 1272.89428) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 610.03059,
			y: 727.15265,
			width: 112.21856,
			height: 8.41639,
			rx: .48819,
			transform: "translate(1146.84542 1306.55985) rotate(-180)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M766.58472,560.20185a94.6422,94.6422,0,1,1-5.992-33.32682c.20638.55577.4076,1.11153.60338,1.67265v.0053q1.31022,3.7,2.30795,7.5377A95.28577,95.28577,0,0,1,766.58472,560.20185Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M660.88028,495.91758a31.96838,31.96838,0,0,0-28.06515-1.14823c-3.924,1.70774-8.05585,4.77121-9.36488,10.30328,5.2943-3.1245,12.14765,1.8122,13.51,9.73171l-.318.08768c-.71955,5.48535.88676,11.45743,3.99663,14.85876a10.45064,10.45064,0,0,1,5.01624-7.43955c2.28491-1.502,4.81264-2.59313,6.55662-5.17495,2.06752-3.06077,2.59254-7.53407,3.41388-11.6148S658.00521,497.05467,660.88028,495.91758Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M631.24471,542.59621c-1.46627,2.202-3.42477,3.5836-5.18213,5.30394a11.92961,11.92961,0,0,0-3.76885,7.04539c-.22235,1.91619.12173,3.8641.07405,5.80154-.04756,1.93731-.6934,4.11816-2.01143,4.59988-2.08031.75161-3.66831-3.11249-5.80678-3.38245-1.6992-.21175-3.22892,2.46141-2.73667,4.77989s2.80549,3.34536,4.13412,1.83148c1.2016,2.01672.35461,5.6745-1.45037,6.29378-.19061,1.27041-.3811,2.53553-.56642,3.80588-4.56285-3.1919-9.17333-6.43665-13.05332-11.11071a33.725,33.725,0,0,1-7.68593-18.16669c-.50284-5.37275.24347-11.51831-2.22317-15.65237-1.97447-3.30833-5.36222-4.03888-8.41119-3.83237-.55576.037-1.11682.10055-1.67264.16936a94.237,94.237,0,0,1,6.82305-15.61534,6.68485,6.68485,0,0,0,1.70974-1.064c2.83728-2.40843,4.0971-7.28364,6.39968-10.65549q.22235-.32556.46052-.63517c2.35557-3.07546,5.51038-4.65816,8.55935-6.12973,6.749-3.27654,13.69379-6.59547,20.81866-6.14025l-2.02732.19585q-3.54916,9.9409-7.10368,19.8818-.54,1.52442-1.0904,3.05426c-1.34452,3.76879-2.73138,7.78118-2.52493,12,.12174,2.49844.98979,5.1663,2.64137,6.02382,1.54032.794,3.22362-.18,4.711-1.14338.62994-.4023,1.25458-.8046,1.88446-1.21219,2.26026-1.45567,4.764-2.94836,7.1513-1.97441,2.18615.88931,3.80058,3.85886,4.10763,7.06136A14.11737,14.11737,0,0,1,631.24471,542.59621Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M644.68757,587.84212q-9.90194-6.09673-19.80393-12.19347l.112-.28861c-4.10438,1.56328-5.8084,8.85905-5.13009,14.82542s2.9783,11.3,4.1402,17.11348a45.42467,45.42467,0,0,1-1.71258,23.83542A195.2048,195.2048,0,0,0,645.224,599.53648a16.905,16.905,0,0,0,2.07422-4.59929,7.31677,7.31677,0,0,0-.485-5.204A5.7936,5.7936,0,0,0,644.68757,587.84212Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M618.63446,513.89674a7.29941,7.29941,0,0,0-.33454,5.30833,5.884,5.884,0,0,0,3.28744,3.04476l3.64753,1.808c1.21347.60148,2.52141,1.209,3.75845.71411,1.492-.59688,2.52651-2.936,2.2589-5.10748-.28483-2.31078-1.74138-3.90028-3.08848-5.25387q-2.82776-2.84131-5.65549-5.68264l-1.06243,1.30127A14.18913,14.18913,0,0,0,618.63446,513.89674Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M747.03111,538.59972q2.46148.5796,4.92283,1.15921c-.28586,5.54217-3.03307,10.67144-6.71721,12.52935-1.53508.77287-3.24482,1.05866-4.51523,2.5038-1.14861,1.31273-1.73093,3.35589-2.26556,5.30916q-1.40541,5.11341-2.8108,10.2267c-1.00568,3.67361-2.29722,7.75481-4.91216,9.07815-2.24437,1.138-4.81163-.25414-6.53726-2.58852-1.72563-2.33431-2.779-5.47329-3.80064-8.53279.06352,3.33477-1.48739,6.60607-3.68414,7.76528-2.20205,1.15921-4.88051.11114-6.352-2.47724-1.05867-1.858-1.498-4.30885-2.53553-6.19324-1.03747-1.88439-3.213-2.96426-4.34581-1.1963-.74638,1.17517-.65113,2.97485-1.02164,4.46761a4.85129,4.85129,0,0,1-4.05465,3.90118,6.7615,6.7615,0,0,1-4.854-2.21794,21.98809,21.98809,0,0,1-6.02912-12.15877,14.50451,14.50451,0,0,1,.16943-6.64846c.65107-2.059,2.22317-3.647,3.78468-3.25535,1.02694-2.17032-1.00038-5.04986-2.82662-4.79579-1.83154.25407-3.266,2.21787-4.7693,3.72652-1.498,1.50859-3.59413,2.60428-5.10279,1.10629a2.0699,2.0699,0,0,1-2.10143,2.19675,7.50624,7.50624,0,0,1-2.73662-1.45037c-3.45656-2.15442-7.84476-.72518-10.30087,3.35066,1.53508-6.532,3.78475-14.02734,8.50106-15.56242,1.92685-.62987,4.02829-.11114,5.84916-1.2016,3.22369-1.932,3.87476-9.23154,1.09046-12.24342.35461,2.84776.28586,6.172-1.21749,8.12-1.50329,1.948-4.65816.6775-4.46755-2.202a1.92912,1.92912,0,0,1-3.58889.7622c-1.00045-1.52441-.91574-4.01755-.20645-5.83849a13.75243,13.75243,0,0,1,3.086-4.3829c2.51433-2.69429,5.06576-5.42037,7.97709-7.11428,2.91663-1.69384,6.28319-2.2655,9.20505-.58219,1.54045.88925,2.89551,2.37141,4.46761,3.15481a3.31073,3.31073,0,0,0,4.61054-1.154c1.16981-2.05381.61928-5.10278,1.05337-7.67.7781-4.53636,5.31446-6.659,7.8288-3.663-1.8791-.48165-3.82177,1.74152-4.05471,4.43588-.23818,2.69429,1.12224,5.41507,2.94312,6.23026,3.05956,1.35506,6.05555-2.05388,8.36879-5.20868q3.62059-4.95456,7.25185-9.90381a11.96908,11.96908,0,0,1,1.29684-1.57741,4.1729,4.1729,0,0,1,5.70093-.11643c2.44552,1.99553,3.5942,6.08733,5.60039,8.90336,2.91133,4.09173,7.26774,5.08688,11.32239,5.88088q4.5337.88134,9.07285,1.77326a94.00511,94.00511,0,0,1,5.26684,11.6295A31.8751,31.8751,0,0,0,747.03111,538.59972Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M763.504,536.09068a19.07933,19.07933,0,0,0-1.00574,5.66914c-2.59375-3.1654-3.00665-9.09921-1.30221-13.20684Q762.5063,532.253,763.504,536.09068Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M756.80265,602.28916a94.89528,94.89528,0,0,1-7.88708,13.19625c-1.90559-.81519-3.95411.64047-5.738,2.00619-1.86326,1.42918-4.10233,2.82133-6.01322,1.51919-1.95321-1.33393-2.58315-5.06569-1.9638-8.02471a21.38162,21.38162,0,0,1,3.66294-7.53771c1.588-2.3714,3.28714-4.83282,5.49449-5.75385,2.21264-.921,5.05509.3811,5.70093,3.52538l1.56681-.053c-.87872-1.20683-.41813-3.70533.76227-4.14466,1.36036-.51343,2.54083,1.35507,3.34536,3.00665C756.09336,600.77521,756.45857,601.52689,756.80265,602.28916Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M696.7944,579.93054c-3.36779.21179-6.03544-3.93417-7.80812-8.0128s-3.39014-8.74292-6.42892-10.81895c-1.73631-1.18627-3.71587-1.349-5.59921-1.92387a6.933,6.933,0,0,1-4.755-4.18646l-2.13634-.863a32.08362,32.08362,0,0,0-8.11107,5.78345,18.12816,18.12816,0,0,0-4.8331,10.56615c-.4081,4.27615,1.09886,9.04425,3.91466,10.65059,2.22491,1.26929,4.81533.46924,7.069,1.63125,2.81577,1.45174,4.48747,5.669,5.1203,9.833s.47244,8.49135.92518,12.70259,1.70052,8.59321,4.2828,10.7513c3.23141,2.7006,7.973.45652,9.4228-4.45951.71115-2.4114.68665-5.13239,1.21854-7.63552.93666-4.40816,3.46423-7.67863,5.46895-11.29463S698.12771,584.127,696.7944,579.93054Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M663.51554,536.6144a8.98853,8.98853,0,0,1,.877.931,3.05876,3.05876,0,0,1-.05384,3.15866,2.93857,2.93857,0,0,0,2.10446-1.06958,13.52846,13.52846,0,0,0,1.61352-2.27287,2.47728,2.47728,0,0,0,.47574-1.98266c-.15909-.45405-.53532-.64773-.79908-.98921a6.722,6.722,0,0,1-.73806-2.14373,3.86638,3.86638,0,0,0-2.802-2.95294l.16878.0323a1.60089,1.60089,0,0,0-.74986,1.70532c.10224.66055.5267,1.20894.48446,1.88263-.0607.96873-1.02885,1.42333-1.08866,2.39219A1.84937,1.84937,0,0,0,663.51554,536.6144Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M657.7454,520.152l.015-.00292a2.69667,2.69667,0,0,0,.28733-.30608Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M658.75542,524.69918a2.937,2.937,0,0,0,.91427-2.91143c-.24465-1.10152-1.11053-1.84212-1.90925-1.63868a1.946,1.946,0,0,1-1.80937.53269c-.49379-.12712-1.03591-.4545-1.46415-.08247a2.2167,2.2167,0,0,0-.49873.97379q-.23776.72994-.47557,1.45973a.92111.92111,0,0,0-.05619.55318.46863.46863,0,0,0,.35936.28569q1.42664.42059,2.85323.84114A2.45818,2.45818,0,0,0,658.75542,524.69918Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M730.55513,587.47761q-.65947-1.07964-1.31891-2.15937a7.2143,7.2143,0,0,0-1.738-2.18223,1.54,1.54,0,0,0-2.19239.21963l.05355.41113a9.28528,9.28528,0,0,1,2.3165,4.51983c.10024.73559.06535,1.4969.15325,2.23569a2.60718,2.60718,0,0,0,.81454,1.82346c.69226.46249,1.50513-.21941,1.99783-1.05147a3.62028,3.62028,0,0,0,.56094-2.30457A4.04118,4.04118,0,0,0,730.55513,587.47761Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M737.45184,588.41432a4.98377,4.98377,0,0,0-.16092-2.00962,4.41143,4.41143,0,0,1,.67132-2.501,8.13046,8.13046,0,0,0,1.046-2.29325,1.91833,1.91833,0,0,0-.05019-1.12305c-.14552-.32692-.498-.476-.70018-.21717l.43267.27866a3.94014,3.94014,0,0,0-1.75588.085,2.17318,2.17318,0,0,0-1.33077,1.50014,9.28173,9.28173,0,0,1-.349,1.55644c-.25809.5305-.75768.70694-1.07163,1.17258a2.80356,2.80356,0,0,0,.04415,2.66342,3.10885,3.10885,0,0,0,1.75851,1.38287C736.51435,589.099,737.21011,589.109,737.45184,588.41432Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M749.73357,592.11986a6.0421,6.0421,0,0,0,.761,1.39674c.588.59227,1.38709.2283,2.10042.08434a3.63157,3.63157,0,0,1,3.45473,1.3857,8.79343,8.79343,0,0,0-5.05745-6.30967,14.8567,14.8567,0,0,0-5.20124-.81336l-.30206.07741C746.25867,590.18154,748.67563,590.13141,749.73357,592.11986Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M697.7157,596.7025l.00442.00976.08787-.16923Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M695.85249,600.30892a16.55493,16.55493,0,0,0-1.0453,2.29622,19.98625,19.98625,0,0,0-.75759,3.929c-.09463.75721-.12381,1.7243.35057,2.09328a.67292.67292,0,0,0,.88032-.11956,3.4822,3.4822,0,0,0,.63816-.94856,21.85209,21.85209,0,0,0,2.15429-5.113,8.89727,8.89727,0,0,0-.35282-5.734Q696.78636,598.51061,695.85249,600.30892Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M677.87809,504.22651a2.12122,2.12122,0,0,0,2.2861.44616,7.54833,7.54833,0,0,0,2.151-1.42082,5.06056,5.06056,0,0,0,1.30394-1.42246,2.88489,2.88489,0,0,0,.26674-2.19764,2.23225,2.23225,0,0,0-1.70142-1.34588q-1.58349-.46959-3.167-.93912l.76365-.68829c-.78568-.42167-1.65489.36091-2.146,1.32977a7.15885,7.15885,0,0,0-.65144,2.00533A5.14759,5.14759,0,0,0,677.87809,504.22651Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M696.51576,497.96967a1.74391,1.74391,0,0,0,2.37685.19336,2.657,2.657,0,0,0,1.05124-1.89349c.07472-.83037-.33586-1.7533-.92226-1.825l.13421-.77746c-1.12961-.204-2.51965-.24486-3.125,1.12692A3.22068,3.22068,0,0,0,696.51576,497.96967Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#0089bd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M864.96638,441.31617H477.643a1.01559,1.01559,0,0,1,0-2.03069H864.96638a1.01559,1.01559,0,0,1,0,2.03069Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#cacaca"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 314.5638,
			cy: 259.77067,
			rx: 10.92534,
			ry: 11.16881,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 352.30587,
			cy: 259.77067,
			rx: 10.92534,
			ry: 11.16881,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 390.04794,
			cy: 259.77067,
			rx: 10.92534,
			ry: 11.16881,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M842.34936,407.532h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M842.34936,415.152h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M842.34936,422.762h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
			transform: "translate(-185.43432 -156.16183)",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .35,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M875.22825,564.89606c6.234-2.71811-6.4085-4.30042-20.752-4.82066s-31.695-.49146-40.86127-1.97121c-8.86513-1.43113-8.21194-3.97577-8.95766-6.2813s-4.15383-4.66951-17.98695-5.182c-17.23785-.63864-45.6641,1.81965-58.67678.34379-12.14326-1.37725-4.925-5.6974-22.632-5.86274-10.11121-.09442-23.13723,1.32986-34.388,1.67358a125.35792,125.35792,0,0,1-23.86052-1.244c-5.48377-.89845-9.30325-2.03749-15.475-2.83107-16.20333-2.08349-47.90478-1.38316-76.19949,1.28712s-52.54848,7.04636-66.22683,11.38066S471.7544,559.99,474.94061,563.60875c2.03457,2.31081,7.241,4.47154,19.87043,5.4001,23.62257,1.73681,65.68047-1.25272,90.09036.32746,13.60468.8807,19.64029,3.06422,31.577,4.259,12.824,1.28361,31.59716,1.35165,50.04182,1.3212,38.4041-.06341,77.7905-.458,117.95262-1.18157,16.775-.30225,34.35193-.69519,52.202-2.13554s36.05643-4.21941,39.82235-6.82467",
				transform: "translate(-185.43432 -156.16183)",
				fill: "#fff"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgDonationsHero);
export { ForwardRef as ReactComponent };
